import { P } from '~components/Typography';
import { NsfwReason, RegisterInbound } from '~features/annals';
import { ButtonInline } from '~shared/ui/molecules';

import CloseIcon from '../../../../../public/assets/icons/close.svg';
import { useCanShowSafeModeSwitchingPopup } from '../../hooks/useSafeModeSwitchingPopup';
import { useSwitchSafeModeWithAgeValidation } from '../../hooks/useSwitchSafeMode';
import { CloseButton, Container, TitleContainer } from './styles';

export const NSFWContactsNotice = ({ counter }: { counter: number }) => {
	const { popupVisible, closePopup } = useCanShowSafeModeSwitchingPopup();
	const updateSafeMode = useSwitchSafeModeWithAgeValidation();

	const handleClick = () => {
		void updateSafeMode(false, {
			force: true,
			nsfwReason: NsfwReason.ChatBanner,
			registerInbound: RegisterInbound.ChatNsfwContactsSwitch,
		});
	};

	if (!popupVisible) {
		return undefined;
	}

	return (
		<Container>
			<TitleContainer>
				<P weight={500} size={'small'}>
					NSFW chats are hidden
				</P>
				<CloseButton type="button" onClick={closePopup}>
					<CloseIcon size={10} />
				</CloseButton>
			</TitleContainer>
			<ButtonInline
				text={`View ${counter} NSFW Chat${counter > 1 ? 's' : ''}`}
				size="small"
				weight={500}
				brandColor={true}
				underline={true}
				onClick={handleClick}
			/>
		</Container>
	);
};
